import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "authData";

function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function saveToStorage(data) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch { }
}

function clearStorage() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch { }
}

const persisted = loadFromStorage();

const initialState = {
    accessToken: persisted?.accessToken ?? null,
    refreshToken: persisted?.refreshToken ?? null,
    sessionKey: persisted?.sessionKey ?? null,
    browserGroupId: persisted?.browserGroupId ?? null,
    user: persisted?.user ?? null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuthData: (state, action) => {
            const { access, refresh, session_key, browser_group_id } = action.payload;
            state.accessToken = access ?? state.accessToken;
            state.refreshToken = refresh ?? state.refreshToken;
            state.sessionKey = session_key ?? state.sessionKey;
            state.browserGroupId = browser_group_id ?? state.browserGroupId;
            saveToStorage({
                // accessToken: state.accessToken,
                refreshToken: state.refreshToken,
                // sessionKey: state.sessionKey,
                // browserGroupId: state.browserGroupId,
                // user: state.user,
            });
        },
        setUser: (state, action) => {
            state.user = action.payload;
            // saveToStorage({
            //     accessToken: state.accessToken,
            //     refreshToken: state.refreshToken,
            //     sessionKey: state.sessionKey,
            //     browserGroupId: state.browserGroupId,
            //     user: state.user,
            // });
        },
        setAccessToken: (state, action) => {
            state.accessToken = action.payload.access;
            if (action.payload.refresh) {
                state.refreshToken = action.payload.refresh;
            }
            saveToStorage({
                refreshToken: state.refreshToken,
            });
        },
        logout: (state) => {
            state.accessToken = null;
            state.refreshToken = null;
            state.sessionKey = null;
            state.browserGroupId = null;
            state.user = null;
            clearStorage();
        },
    },
});

export const { setAuthData, setUser, setAccessToken, logout } = authSlice.actions;
export default authSlice.reducer;